module.exports = __webpack_public_path__ + "static/media/Path Kopi.dc3a5cbe.png";